<template>    
    <page-layout>
        <has-app 
            :app="$route.params.app"
            :universe="$route.params.universe"
        >
            <infinity-page
                icon="$vuetify.icons.app"
                color="teal"
                :loading="loading"
            >
                <app-drawer />
                <template #title>
                    <v-toolbar 
                        flat
                        prominent
                        class="pa-0"
                    >
                        <div>
                            <h1
                                style="font-weight: 300; font-family: lato; font-weight: bold; letter-spacing: initial;"
                            >
                                {{ app.name }}
                            </h1>
                            <h2 
                                style="font-weight: 200"
                                v-html="app.subtitle || '&nbsp;'"
                            />
                        </div>
                        <v-spacer />
                        <build-o 
                            :universe="app.universe"
                            :app="app.name"
                            info
                            class="mt-4"
                        />
                        <app-state
                            :universe="app.universe"
                            :app="app.name"
                            info
                            class="mt-4"
                        />
                    </v-toolbar>
                </template>
                <template #actions>
                    <v-btn 
                        color="deep-purple"
                        class="white--text px-6"                        
                        depressed
                        @click="save"
                    >
                        <v-icon left>
                            mdi-content-save
                        </v-icon> Save
                    </v-btn>
                    <v-spacer />                    
                </template>                
                <v-sheet>        
                        <v-container class="pa-12 pb-6">
                        <v-text-field 
                            v-model="query"
                            filled
                            shaped      
                            placeholder="Search"
                        >
                            <template #prepend-inner>
                                <v-icon>mdi-magnify</v-icon>
                            </template>
                        </v-text-field>   
                        <list-editor 
                            v-model="usernames"
                            label="Username"
                            :all-items="allUsernames"
                        />
                    </v-container>                    
                </v-sheet>
                <template #sidebar>
                    <infinity-sidebar
                        icon="$vuetify.icons.help"
                        title="docs/multiverse"
                    >
                        <h4 class="text-h4 mb-3 text--primary">
                        Settings for the platform
                        </h4>

                        <p class="text--secondary">
                            Settings for the platform can be set on this page
                        </p>

                        <v-btn
                            class="mr-0 white--text"
                            color="deep-purple"                            
                            min-width="100"
                            rounded
                        >
                            I want to know more
                        </v-btn>
                    </infinity-sidebar>
                </template>
            </infinity-page>
        </has-app>
    </page-layout>
</template>
<script>
    import PageLayout from '@/layouts/default/PageLayout'    
    import AppDrawer from '@/layouts/App/Drawer'    
    import BuildO from '../../layouts/App/widgets/BuildO'
    import AppState from '../../layouts/App/widgets/State'
    import { mapState, mapWritableState, mapActions } from 'pinia'
    import { useUsersStore } from '@/store/users-store'
    import { useAppStore } from '@/store/app-store'

    export default {
        components: {
            PageLayout,
            AppDrawer,
            BuildO,
            AppState,
        },
        data: () => ({       
            usernames: {},
            allUsernames: {},   
        }),
        computed: {
            ...mapState(useUsersStore, ['loading', 'users', 'appUsers']),
            ...mapState(useAppStore, ['app']),
            ...mapWritableState(useUsersStore, ['query']),
        },
        watch: {            
            appUsers (v) {
                this.usernames = v
            },
            users (v) {                
                this.allUsernames = v
            },
        },
        async mounted () {            
            await this.loadApp(this.$route.params.universe, this.$route.params.app)
            await this.loadUsers(this.$route.params.universe)
            await this.loadAppUsers(this.$route.params.universe, this.$route.params.app)
        },        
        methods: {
            ...mapActions(useUsersStore, ['loadUsers', 'loadAppUsers', 'saveAppUsers']),
            ...mapActions(useAppStore, ['loadApp']),
            save () {                
                this.saveAppUsers(this.$route.params.universe, this.$route.params.app, this.usernames)
            },            
        },
    }
</script>
<style scoped>
.vjsf >>> .v-card__title {
    font-size: 24px ! important;
    font-weight: 600;
    font-family: 'lato' ! important;
}
</style>
